module.exports = __webpack_public_path__ + "img/9791185871073.3dcd390d.jpg";